module.exports = __webpack_public_path__ + "static/10-f1e63a5d73f9a2a00115e91f80d1727d.png";